import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-609c7138"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "bg-light mb-2 mt-3 py-1 px-2 shadow-sm rounded" };
const _hoisted_2 = { class: "menus-container" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = {
    class: "btn btn-quadrado valor-descricao-container shadow-none",
    style: { "width": "100%" }
};
const _hoisted_5 = { class: "valor" };
const _hoisted_6 = { class: "descricao" };
const _hoisted_7 = { key: 1 };
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "text-center" }, "Você ainda não realizou doações.", -1));
const _hoisted_9 = [
    _hoisted_8
];
const _hoisted_10 = { id: "lista-doacoes" };
const _hoisted_11 = ["onClick"];
const _hoisted_12 = { class: "valor" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_MobileLikeNavHeader = _resolveComponent("MobileLikeNavHeader");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_MobileLikeNavHeader, {
            title: "Doações Realizadas",
            height: "100px",
            "go-back-url": "/restrito#/"
        }),
        _createElementVNode("div", _hoisted_2, [
            (_ctx.listaDoacoesConfirmadas.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.moneyToReais(_ctx.totalDoado)), 1)
                        ]),
                        _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_6, " Parabéns! Você já fez " + _toDisplayString(_ctx.listaDoacoesConfirmadas.length) + " " + _toDisplayString(_ctx.listaDoacoesConfirmadas.length > 1 ? 'doações' : 'doação') + ". ", 1)
                        ])
                    ])
                ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
        ]),
        _createElementVNode("ul", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listaDoacoes, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                    onClick: ($event) => (_ctx.showDetalhesDoacao(item)),
                    class: _normalizeClass('status-' + item.status_movimentacao_id)
                }, [
                    _createElementVNode("i", {
                        class: _normalizeClass(item.icone_forma_pagamento)
                    }, null, 2),
                    _createTextVNode(" " + _toDisplayString(_ctx.converteData(item.created_at.substr(0, 10))) + " - ", 1),
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.moneyToReais(item.valor_raw)), 1)
                ], 10, _hoisted_11));
            }), 256))
        ])
    ]));
}
